export function extractListProps({ dataError, noDataState, noResultsState, errorDataState, dataFiltered, loading, footer, widthStrategy, scrollToSelectedItem, virtualized, }) {
    return {
        dataError,
        noDataState,
        noResultsState,
        errorDataState,
        dataFiltered,
        loading,
        footer,
        widthStrategy,
        scrollToSelectedItem,
        trigger: 'clickAndFocusVisible',
        placement: 'bottom',
        'data-test-id': 'field-select__list',
        virtualized,
        scroll: true,
        marker: true,
    };
}
